import { BillingCode } from 'src/participantHistory/intakeNote/billingCodeConstants'
import { z } from 'zod'

const MAX_INPUT_LENGTH = 3000

export const TREATMENT_PLAN_COMPREHENSIVE_FORM_SCHEMA = z.object({
  date: z.string(),
  FIRST_NAME: z.string().min(1),
  LAST_NAME: z.string().min(1),
  MEMBER_ID: z.string().min(1),
  PROVIDER_NAME: z.string().min(1),
  LICENSE_TYPE: z.string().min(1),
  PRESENTING_PROBLEM: z.string().max(MAX_INPUT_LENGTH),
  LONG_TERM_GOAL: z.string().max(MAX_INPUT_LENGTH),
  BILLING_CODES: z
    .array(z.enum(Object.values(BillingCode) as [string, ...string[]]))
    .min(1, 'At least one billing code is required'),
  SHORT_TERM_GOAL: z.object({
    SPECIFIC: z.string().max(MAX_INPUT_LENGTH),
    MEASURABLE: z.string().max(MAX_INPUT_LENGTH),
    ACHIEVABLE: z.string().max(MAX_INPUT_LENGTH),
    RELEVANT: z.string().max(MAX_INPUT_LENGTH),
    TIME_BOUND: z.string().max(MAX_INPUT_LENGTH),
    GOAL_STATEMENT: z.string().max(MAX_INPUT_LENGTH),
  }),
  INTERVENTIONS_AND_PARTICIPANT_AGREEMENT: z.object({
    PHQ9_GAD7: z.boolean(),
    BIOFEEDBACK: z.boolean(),
    IN_APP_CHAT: z.boolean(),
    CBT_MINDFULLNESS_ACT: z.boolean(),
    PSYCHOEDUCATION: z.boolean(),
    TELEHEALTH_VIDEO: z.boolean(),
    PEER_SUPPORT: z.boolean(),
    STRENGTHS: z.string().max(MAX_INPUT_LENGTH).optional(),
    OTHER: z.string().max(MAX_INPUT_LENGTH).optional(),
    PARTICIPANT_AGREEMENT: z.boolean().refine((val) => val, 'Participant agreement is required'),
  }),
})

export type TreatmentPlanComprehensiveFormType = z.infer<typeof TREATMENT_PLAN_COMPREHENSIVE_FORM_SCHEMA>
